import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useResizeDetector } from 'react-resize-detector';
import { OnResizeCallback } from 'react-resize-detector/build/types/types';
import KubitTooltip from '../../../../components/KubitTooltip';

interface IProps {
  name: string;
  height?: number;
}

const NameWrapper = styled.div<{ $height?: number }>`
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  height: ${({ $height }) => ($height ? `${$height}px` : undefined)};
`;

const LongNameWithTooltip = ({ name, height }: IProps) => {
  const [currentClientWidth, setCurrentClientWidth] = useState<
    number | undefined
  >(undefined);
  const [currentScrollWidth, setCurrentScrollWidth] = useState<
    number | undefined
  >(undefined);

  const onResize: OnResizeCallback = useCallback((width, _height) => {
    setCurrentClientWidth(width);
  }, []);

  useResizeDetector({ onResize });
  const tooltipEnabled = (currentScrollWidth ?? 0) > (currentClientWidth ?? 0);

  const refCallback = useCallback((node: HTMLDivElement | null) => {
    setCurrentScrollWidth(node?.scrollWidth);
    setCurrentClientWidth(node?.clientWidth);
  }, []);

  return (
    <KubitTooltip disabled={!tooltipEnabled} content={name} noOpenDelay={true}>
      <NameWrapper $height={height} ref={refCallback}>
        {name}
      </NameWrapper>
    </KubitTooltip>
  );
};

export default LongNameWithTooltip;
